// extracted by mini-css-extract-plugin
export default {"uploadImageVideo":"uploadImageVideo_uploadImageVideo__HrvJ6","uploadCard":"uploadImageVideo_uploadCard__84K4i","previewBox":"uploadImageVideo_previewBox__KmGbh","previewItem":"uploadImageVideo_previewItem__-h-Aj","deleteIcon":"uploadImageVideo_deleteIcon__M1qZG","filePreview":"uploadImageVideo_filePreview__LZf0a","fileLabel":"uploadImageVideo_fileLabel__sjUbE"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"uploadImageVideo\":\"uploadImageVideo_uploadImageVideo__HrvJ6\",\"uploadCard\":\"uploadImageVideo_uploadCard__84K4i\",\"previewBox\":\"uploadImageVideo_previewBox__KmGbh\",\"previewItem\":\"uploadImageVideo_previewItem__-h-Aj\",\"deleteIcon\":\"uploadImageVideo_deleteIcon__M1qZG\",\"filePreview\":\"uploadImageVideo_filePreview__LZf0a\",\"fileLabel\":\"uploadImageVideo_fileLabel__sjUbE\"}";
        // 1793760842154
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  